export default __webpack_public_path__ + "static/media/coverrock-II-rockwool-platte_comp.9a8e685c.jpg";